'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PaymentStatusConstants = require('./PaymentStatusConstants');

var constants = _interopRequireWildcard(_PaymentStatusConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentStatus = function () {
    (0, _createClass3.default)(PaymentStatus, null, [{
        key: 'create',
        value: function create() {
            var paymentStatusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : constants.PAYMENT_STATUS_NOT_PAY;

            return new PaymentStatus(paymentStatusId);
        }
    }]);

    function PaymentStatus(paymentStatusId) {
        (0, _classCallCheck3.default)(this, PaymentStatus);

        this.paymentStatusId = parseInt(paymentStatusId, 10) || 0;
    }

    (0, _createClass3.default)(PaymentStatus, [{
        key: 'isPayActionAvaliable',
        value: function isPayActionAvaliable() {
            return this.paymentStatusId === constants.PAYMENT_STATUS_NOT_PAY;
        }
    }, {
        key: 'isCanceled',
        value: function isCanceled() {
            return this.paymentStatusId === constants.PAYMENT_STATUS_CANCEL;
        }
    }, {
        key: 'isRevert',
        value: function isRevert() {
            return this.paymentStatusId === constants.PAYMENT_STATUS_RETURN || this.paymentStatusId === constants.PAYMENT_STATUS_PARTIALLY_RETURN;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.statusSlug;
        }
    }, {
        key: 'status',
        get: function get() {
            return this.paymentStatusId;
        }
    }, {
        key: 'isPay',
        get: function get() {
            return this.paymentStatusId === constants.PAYMENT_STATUS_PAY;
        }
    }, {
        key: 'isOutdated',
        get: function get() {
            return this.paymentStatusId === constants.PAYMENT_STATUS_OUTDATED;
        }
    }, {
        key: 'statusSlug',
        get: function get() {
            var _lablesTranslate;

            var lablesTranslate = (_lablesTranslate = {}, (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_MONEY_TRANSFER, 'store.order_status.money_transfer'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_RETURN, 'store.order_status.return'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_PARTIALLY_RETURN, 'store.order_status.partially_return'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_PAY, 'store.order_status.paid'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_NOT_PAY, 'store.order_status.not_paid'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_OUTDATED, 'store.order_status.outdated'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_CANCEL, 'store.order_status.cancelled'), _lablesTranslate);

            if (this.paymentStatusId && this.paymentStatusId in lablesTranslate) {
                return lablesTranslate[this.paymentStatusId];
            }

            return lablesTranslate[constants.PAYMENT_STATUS_NOT_PAY];
        }
    }]);
    return PaymentStatus;
}();

exports.default = PaymentStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Order/PaymentStatus.js
// module id = 163
// module chunks = 0